import { settings } from '@pixi/core';
export { settings } from '@pixi/core';

settings.UPLOADS_PER_FRAME = 4;
//# sourceMappingURL=settings.mjs.map
